import { useState } from 'react'

import { ApolloError, ApolloQueryResult } from '@apollo/client'
import {
  GetCompetenciesFromSuggestionsModalDocument,
  GetCompetenciesFromSuggestionsModalQuery,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

type Suggestion =
  GetCompetenciesFromSuggestionsModalQuery['jobCatalog']['roleCompetencySuggestionsConnection']['nodes'][number]

interface Return {
  suggestions: Suggestion[]
  isLoading: boolean
  remove: (name: string) => void
  refetch: () => Promise<ApolloQueryResult<GetCompetenciesFromSuggestionsModalQuery>>
  error?: ApolloError
}

const useRoleCompetenciesSuggestions = (roleName: string, companyId: number): Return => {
  const [suggestions, setSuggestions] = useState<Suggestion[]>([])
  const { loading, error, refetch, networkActivity } = useQuery(
    GetCompetenciesFromSuggestionsModalDocument,
    {
      variables: { roleName, companyId },
      onCompleted: (data) => {
        setSuggestions(data.jobCatalog.roleCompetencySuggestionsConnection.nodes)
      },
    }
  )

  const remove = (name: string) => {
    const nextSuggestions = suggestions.filter((x) => x.competencyName !== name)
    setSuggestions(nextSuggestions)
  }

  return { suggestions, remove, isLoading: loading || networkActivity, error, refetch }
}

export default useRoleCompetenciesSuggestions
